import { render } from "./NumberButtonsComponent.vue?vue&type=template&id=4a589bb0"
import script from "./NumberButtonsComponent.vue?vue&type=script&lang=js"
export * from "./NumberButtonsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kreigdurham/Documents/Git/af3-shortcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__